var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngleUp = function SvgAngleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 9.998 4.622-5.021a.517.517 0 0 1 .754 0L13 9.998",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAngleUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjk5OTI3IDkuOTk4NDFMNy42MjIzNCA0Ljk3Njg5QzcuNjcwNjkgNC45MjUzOCA3LjcyOTA4IDQuODg0MzMgNy43OTM5IDQuODU2MjdDNy44NTg3MyA0LjgyODIgNy45Mjg2MyA0LjgxMzcyIDcuOTk5MjcgNC44MTM3MkM4LjA2OTkxIDQuODEzNzIgOC4xMzk4IDQuODI4MiA4LjIwNDYzIDQuODU2MjdDOC4yNjk0NiA0Ljg4NDMzIDguMzI3ODUgNC45MjUzOCA4LjM3NjE5IDQuOTc2ODlMMTIuOTk5MyA5Ljk5ODQxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";